import { PROP_ANY, PROP_BOOLEAN, PROP_NUMBER, PROP_STRING, register, registerFormWidget } from '@wm/components/base';
import { FormWidgetType } from '@wm/core';

export const textareaProps = new Map(
    [
        ['autofocus', PROP_BOOLEAN],
        ['autotrim', {value: true, ...PROP_BOOLEAN}],
        ['class', PROP_STRING],
        ['datavaluesource', PROP_ANY],
        ['datavalue', PROP_STRING],
        ['disabled', PROP_BOOLEAN],
        ['hint', PROP_STRING],
        ['maxchars', PROP_NUMBER],
        ['name', PROP_STRING],
        ['placeholder', {value: 'Place your text', ...PROP_STRING}],
        ['readonly', PROP_BOOLEAN],
        ['required', PROP_BOOLEAN],
        ['shortcutkey', PROP_STRING],
        ['show', {value: true, ...PROP_BOOLEAN}],
        ['tabindex', {value: 0, ...PROP_NUMBER}],
        ['updateon', PROP_STRING]
    ]
);

export const registerProps = () => {
    register(
        'wm-textarea',
        textareaProps
    );
    registerFormWidget(
        FormWidgetType.TEXTAREA,
        new Map(textareaProps)
    );
};
